/* erx-coll.js - collection pages (sections/erx-coll-all.liquid = c13, sections/erx-coll-desks.liquid = c09).
   Never adds to cart: the swatches and the desk chooser only change what is shown (picture, price, labels)
   and where the buttons lead (?variant=). All data is rendered by Liquid into <script type="application/json">;
   prices arrive as finished strings from snippets/ergonix-money (market currency), nothing is computed here. */
(function () {
  'use strict';
  var readJson = function (el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } };

  /* ---------- c13: chair and desk features, swatch -> picture, name, price, links ---------- */
  var initFeat = function (feat) {
    var dataEl = feat.querySelector('[data-erx-coll-json]');
    var data = dataEl && readJson(dataEl);
    if (!data || !data.v) return;
    var img = feat.querySelector('[data-erx-coll-img]');
    var name = feat.querySelector('[data-erx-coll-name]');
    var pd = feat.querySelector('[data-erx-coll-pd]');
    var pm = feat.querySelector('[data-erx-coll-pm]');
    var links = feat.querySelectorAll('[data-erx-coll-link]');
    var sws = feat.querySelectorAll('[data-erx-coll-sw]');
    Array.prototype.forEach.call(sws, function (b) {
      b.addEventListener('click', function () {
        var d = data.v[+b.getAttribute('data-erx-coll-sw')];
        if (!d) return;
        Array.prototype.forEach.call(sws, function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
        if (img && d.src) { img.removeAttribute('srcset'); img.src = d.src; if (d.srcset) img.srcset = d.srcset; }
        if (name && d.name) name.textContent = d.name;
        if (pd && d.pd) pd.innerHTML = d.pd;
        if (pm && d.pm) pm.innerHTML = d.pm;
        if (d.url) Array.prototype.forEach.call(links, function (a) { a.href = d.url; });
      });
    });
  };

  /* ---------- c09: desk chooser. State = size + top + frame; key "frame|top|size" picks each model's variant ---------- */
  var initDesks = function (root) {
    var dataEl = root.querySelector('[data-erx-coll-dk-json]');
    var data = dataEl && readJson(dataEl);
    if (!data || !data.m) return;
    var st = { size: root.getAttribute('data-size') || '120', top: root.getAttribute('data-top') || 'walnut', frame: root.getAttribute('data-frame') || 'black' };
    var q = function (s) { return root.querySelectorAll(s); };
    var setImg = function (img, d) { if (!img || !d || !d.src) return; img.removeAttribute('srcset'); img.src = d.src; if (d.ss) img.srcset = d.ss; };
    var radio = function (list, attr, val) {
      Array.prototype.forEach.call(list, function (b) { var on = b.getAttribute(attr) === val; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    };
    var render = function () {
      radio(q('[data-erx-dk-size]'), 'data-erx-dk-size', st.size);
      radio(q('[data-erx-dk-top]'), 'data-erx-dk-top', st.top);
      radio(q('[data-erx-dk-frame]'), 'data-erx-dk-frame', st.frame);
      var tn = root.querySelector('[data-erx-dk-tname]'); if (tn) tn.textContent = data.tops[st.top] || '';
      var fn = root.querySelector('[data-erx-dk-fname]'); if (fn) fn.textContent = data.frames[st.frame] || '';
      var cs = root.querySelector('[data-erx-dk-chip="size"]'); if (cs) cs.textContent = data.sizes[st.size] || '';
      var ct = root.querySelector('[data-erx-dk-chip="top"]'); if (ct) ct.textContent = data.tops[st.top] || '';
      var cf = root.querySelector('[data-erx-dk-chip="frame"]'); if (cf) cf.textContent = data.frameChips[st.frame] || '';
      // size tiles follow the chosen colours (first model has every frame × top × size)
      Array.prototype.forEach.call(q('[data-erx-dk-simg]'), function (img) { setImg(img, data.m[0] && data.m[0].v[st.frame + '|' + st.top + '|' + img.getAttribute('data-erx-dk-simg')]); });
      var key = st.frame + '|' + st.top + '|' + st.size, n = 0;
      Array.prototype.forEach.call(q('[data-erx-dk-model]'), function (card) {
        var m = data.m[+card.getAttribute('data-erx-dk-model')], d = m && m.v[key];
        card.hidden = !d;
        if (!d) return;
        n++;
        setImg(card.querySelector('[data-erx-dk-img]'), d);
        var pr = card.querySelector('[data-erx-dk-price]'); if (pr) pr.innerHTML = d.p;
        Array.prototype.forEach.call(card.querySelectorAll('[data-erx-dk-link]'), function (a) { a.href = d.url; });
      });
      var t = root.querySelector('[data-erx-dk-title]'); if (t) t.textContent = n >= 2 ? data.t.two : (n === 1 ? data.t.one : data.t.none);
    };
    Array.prototype.forEach.call(q('[data-erx-dk-size]'), function (b) { b.addEventListener('click', function () { st.size = b.getAttribute('data-erx-dk-size'); render(); }); });
    Array.prototype.forEach.call(q('[data-erx-dk-top]'), function (b) { b.addEventListener('click', function () { st.top = b.getAttribute('data-erx-dk-top'); render(); }); });
    Array.prototype.forEach.call(q('[data-erx-dk-frame]'), function (b) { b.addEventListener('click', function () { st.frame = b.getAttribute('data-erx-dk-frame'); render(); }); });
  };

  var boot = function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-erx-coll-feat]'), initFeat);
    Array.prototype.forEach.call(document.querySelectorAll('[data-erx-coll-dk]'), initDesks);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Phone: the size row is a swipe row. On a size collection (e.g. 160 × 80) start it at the chosen card, not at
   120 × 60, which left the selected card off-screen (QA 2026-10-12). */
(function () {
  function go() {
    var row = document.querySelector('.erx-coll-dk-sizes');
    var on = row && row.querySelector('.erx-coll-dk-size.is-on');
    if (!on || row.scrollWidth <= row.clientWidth + 2) return;
    var pad = parseFloat(getComputedStyle(row).scrollPaddingLeft) || parseFloat(getComputedStyle(row).paddingLeft) || 0;
    row.scrollLeft += on.getBoundingClientRect().left - row.getBoundingClientRect().left - pad;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
